import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massDestroyBlogs } from "../../api/apiBlogs";
import parseError from "../../utils/parseError";

/**
 * Hook لحذف جماعي للمدونات (soft delete)
 */
export function useDeleteAllBlogs() {
    const queryClient = useQueryClient();

    const {
        mutate: deleteAllBlogsMutate,
        isPending,
    } = useMutation({
        mutationFn: massDestroyBlogs,
        onSuccess: (response) => {
            toast.success(response.message || "Deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["blogs"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete blogs");
        },
    });

    return {
        deleteAllBlogsMutate,
        isPending,
    };
}
